var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailNewsletter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.640137L6.23 3.00014H3V5.00014L0.97 6.29014C0.39 6.64014 0 7.27014 0 8.00014V18.0001C0 19.1101 0.9 20.0001 2 20.0001H18C19.11 20.0001 20 19.1101 20 18.0001V8.00014C20 7.27014 19.61 6.64014 19.03 6.29014L17 5.00014V3.00014H13.77L10 0.640137ZM5 5.00014H15V9.88014L10 13.0001L5 9.88014V5.00014ZM6 6.00014V7.50014H14V6.00014H6ZM3 7.38014V8.63014L2 8.00014L3 7.38014ZM17 7.38014L18 8.00014L17 8.63014V7.38014ZM6 8.50014V10.0001H14V8.50014H6Z",
    fill: "#ABACF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNewsletter);
export default __webpack_public_path__ + "static/media/email-newsletter.9e93413e95ccf973c554a702e21e1376.svg";
export { ForwardRef as ReactComponent };